import React, { useRef, useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import InputField from '@common/InputRuleFeild';
import Header from '@components/common/Header';
import { getValue } from '@utils/lodash';
import SimpleReactValidator from 'simple-react-validator';
import _ from 'lodash';
import { Col, Row } from 'reactstrap';
import { toast } from 'react-toastify';
import { useParams, useNavigate } from 'react-router-dom';
import './roles-details.scss';
import { useCallbackPrompt } from '@prompt/useCallbackPrompt';
import PromptModal from '@prompt/modal';
import { formatText } from '@common/text-helpers';
import {
  createRole,
  getSpecificRole,
  rolesAdminPermissionList,
  rolesPermissionList,
  updateRole,
} from '@services/roles.service';
import AdminNavigation from '@components/Admin/admin-navigation';
import Layout from '@layouts/withoutNaviagtion/withoutNavigationLayout';
import RolesNavigation from '@components/Admin/roles-navigation';
import ExpenseTabNavigation from '@pages/Client/Expense/Detail/DetailContainer/TabHeader/tabheader-navigation';
import RolesTabNavigateion from './tabheader-navigation';
import RolesSection from './roles-section';
import NoAccessPage from '@components/common/NoAccess';
import {
  getlocationManagementCities,
  getlocationManagementCountries,
  getlocationManagementStates,
} from '@services/list-management.service';
import { StylesConfig } from 'react-select';
import { QueryRequestHelper } from '@common/query-request-helper';

interface IAdminUserControlRolesDetailsProps {}

const AdminUserControlRolesDetails: React.FunctionComponent<
  IAdminUserControlRolesDetailsProps
> = (props: any) => {
  let params = useParams();
  let navigate = useNavigate();
  /* -------------------------------------------------------------------------- */
  /*                               UseState Section                             */
  /* -------------------------------------------------------------------------- */
  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState(0);
  const [isLoading, setIsLoading] = React.useState(true);
  const [request, setRequest] = React.useState({
    title: '',
    description: '',
    countries: [],
    states: [],
    locations: [],
    travel_type_access: null,
  });

  const [dirtyFields, setDirtyFields] = useState({
    title: '',
    description: '',
    countries: [],
    states: [],
    locations: [],
    travel_type_access: null,
  });

  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [locationList, setLocationList] = useState([]);

  const [permissionList, setPermissionList] = useState<any>({});
  const [selectedPermissions, setSelectedPermissions] = useState<any>([]);
  const [mainPermissions, setMainPermissions] = useState([]);
  const [allList, setAllList] = useState<any>([]);

  const [permissionList1, setPermissionList1] = useState<any>({});
  const [selectedPermissions1, setSelectedPermissions1] = useState<any>([]);
  const [mainPermissions1, setMainPermissions1] = useState([]);
  const [allList1, setAllList1] = useState<any>([]);
  /* -------------------------------------------------------------------------- */
  /*                               UseEffect Section                            */
  /* -------------------------------------------------------------------------- */

  useEffect(() => {
    if (props.permissionAPITriggered) {
      getCountriesList();
      getData();
      if (getValue(params, `id`, '')) {
        getRole(getValue(params, `id`, ''));
      }
    }
  }, [props.permissionAPITriggered]);

  useEffect(() => {
    if (props.permissionAPITriggered) {
      if (request.countries.length > 0) {
        getStatesList(request.countries);
      }
    }
  }, [request.countries, props.permissionAPITriggered]);

  useEffect(() => {
    if (props.permissionAPITriggered) {
      if (request.states) {
        getLocationsList(request.states);
      }
    }
  }, [request.states, props.permissionAPITriggered]);
  /* -------------------------------------------------------------------------- */
  /*                               API Section                                  */
  /* -------------------------------------------------------------------------- */

  const getCountriesList = async () => {
    try {
      let resp = await getlocationManagementCountries('');
      if (resp) {
        setCountryList(
          getValue(resp, `data.countries`, []).map((item: object) => ({
            ...item,
            value: getValue(item, `name`, ''),
            label: getValue(item, `name`, ''),
          })),
        );
      }
    } catch (error) {}
  };

  const getStatesList = async (countryIds: any[]) => {
    try {
      let payload = {
        countryId: countryIds?.map((c) => c.id),
      };
      let queryRequest = QueryRequestHelper(payload);
      let resp = await getlocationManagementStates(queryRequest);
      if (resp) {
        setStateList(
          getValue(resp, `data.states`, []).map((item: object) => ({
            ...item,
            value: getValue(item, `name`, ''),
            label: getValue(item, `name`, ''),
          })),
        );
      }
    } catch (error) {}
  };

  const getLocationsList = async (stateIds: any[]) => {
    try {
      let payload = {
        stateId: stateIds?.map((s) => s.id),
      };
      let queryRequest = QueryRequestHelper(payload);
      const resp = await getlocationManagementCities(queryRequest);

      if (resp) {
        const cities = getValue(resp, 'data.cities', []);

        setLocationList(
          cities?.map((item: object) => ({
            ...item,
            value: getValue(item, 'name', ''),
            label: getValue(item, 'name', ''),
          })),
        );
      }
    } catch (error) {
      console.error('Error fetching locations:', error);
    }
  };

  const getRole = async (id: string) => {
    try {
      let resp = await getSpecificRole(id);
      if (resp) {
        const permittedCountries = getValue(
          resp,
          `data.report_download_permitted_countries`,
          [],
        );
        const permittedStates = getValue(resp, `data.permitted_states`, []);
        const permittedLocations = getValue(
          resp,
          `data.permitted_locations`,
          [],
        );

        setDirtyFields({
          ...dirtyFields,
          title: getValue(resp, `data.title`, ''),
          description: getValue(resp, `data.description`, ''),
          countries: permittedCountries,
          states: permittedStates,
          locations: permittedLocations,
          travel_type_access: getValue(resp, `data.travel_type_access`, null),
        });

        setRequest({
          ...request,
          title: getValue(resp, `data.title`, ''),
          description: getValue(resp, `data.description`, ''),
          countries: permittedCountries,
          states: permittedStates,
          locations: permittedLocations,
          travel_type_access: getValue(resp, `data.travel_type_access`, null),
        });

        if (getValue(resp, `data.permissions.length`, 0) > 0) {
          getValue(resp, `data.permissions`, []).map((item: any) => {
            if (item.split('admin').length === 2) {
              selectedPermissions1.push(item);
            } else {
              selectedPermissions.push(item);
            }
          });
        }
      }
    } catch (error) {}
  };

  const getData = async () => {
    try {
      setIsLoading(true);
      let resp = await rolesPermissionList();
      let adminResp = await rolesAdminPermissionList();
      if (adminResp) {
        let arr: any = [];
        getValue(adminResp, `data.permissions`, []).filter((item: any) => {
          if (item.is_tab_group) {
            arr.push(item);
          } else {
            arr.push({
              component: item.component,
              is_tab_group: true,
              items: [
                { component: item.component, permissions: item.permissions },
              ],
            });
          }
        });
        setMainPermissions1(arr);
        var grouped = _.mapValues(
          _.groupBy(getValue(adminResp, `data.permissions`, []), 'component'),
        );
        setPermissionList1(grouped);
        for (let i = 0; i < getValue(arr, `length`, 0); i++) {
          getValue(arr[i], `items`, []).map((item: any) => {
            return getValue(item, `permissions`, []).map((per: any) => {
              return allList1.push(getValue(per, `value`, ''));
            });
          });
        }
        setAllList1([...allList1]);
      }

      if (resp) {
        let arr: any = [];
        getValue(resp, `data.permissions`, []).filter((item: any) => {
          if (item.is_tab_group) {
            arr.push(item);
          } else {
            arr.push({
              component: item.component,
              is_tab_group: true,
              items: [
                { component: item.component, permissions: item.permissions },
              ],
            });
          }
        });
        setMainPermissions(arr);
        var grouped = _.mapValues(
          _.groupBy(getValue(resp, `data.permissions`, []), 'component'),
        );
        setPermissionList(grouped);
        for (let i = 0; i < getValue(arr, `length`, 0); i++) {
          getValue(arr[i], `items`, []).map((item: any) => {
            return getValue(item, `permissions`, []).map((per: any) => {
              return allList.push(getValue(per, `value`, ''));
            });
          });
        }
        setAllList([...allList]);
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const [submitLoading, setSubmitLoading] = useState(false);
  const handleSubmit = async () => {
    const formValid = simpleValidator.current.allValid();
    if (!formValid) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    } else {
      if (
        getValue(selectedPermissions, `length`, 0) > 0 ||
        getValue(selectedPermissions1, `length`, 0) > 0
      ) {
        try {
          let payload = {
            title: request.title,
            description: request.description,
            report_download_country_ids: getCountryIds(),
            permitted_state_ids: getStateIds(),
            permitted_location_ids: getLocationIds(),
            travel_type_access: request.travel_type_access ?? null,
            permissions: selectedPermissions.concat(selectedPermissions1),
          };

          console.log(payload, request.travel_type_access, '999999999');

          setSubmitLoading(true);
          if (getValue(params, `id`, '')) {
            let resp = await updateRole(getValue(params, `id`, ''), payload);
            if (resp) {
              navigate(`/admin/user-controls/roles`);
              toast.success('Updated successfully');
              setSubmitLoading(false);
            } else {
              setSubmitLoading(false);
            }
          } else {
            let resp = await createRole(payload);
            if (resp) {
              navigate(`/admin/user-controls/roles`);
              toast.success('Created successfully');
              setSubmitLoading(false);
            } else {
              setSubmitLoading(false);
            }
          }
        } catch (error) {
          setSubmitLoading(false);
        }
      } else {
        toast.error('All fields are mandatory');
      }
    }
  };

  /* -------------------------------------------------------------------------- */
  /*                          Client Onchange section                           */
  /* -------------------------------------------------------------------------- */
  const handleChangeCountries = (e: any) => {
    setRequest({
      ...request,
      countries: e || [],
    });
  };

  const getCountryIds = () => {
    return getValue(request, `countries`, []).map((country: any) =>
      getValue(country, `id`, ''),
    );
  };

  const handleChangeStates = (e: any) => {
    setRequest({
      ...request,
      states: e || [],
    });
  };

  const getStateIds = () => {
    return getValue(request, `states`, []).map((state: any) =>
      getValue(state, `id`, ''),
    );
  };

  const handleChangeLocations = (e: any) => {
    setRequest({
      ...request,
      locations: e || [],
    });
  };

  const getLocationIds = () => {
    return getValue(request, `locations`, []).map((location: any) =>
      getValue(location, `id`, ''),
    );
  };

  const handleChangePermission = (value: string) => {
    let selected = selectedPermissions.filter((item: String) => item === value);
    if (getValue(selected, `length`, 0) > 0) {
      let selected = selectedPermissions.filter(
        (item: String) => item !== value,
      );
      setSelectedPermissions(selected);
    } else {
      selectedPermissions.push(value);
      setSelectedPermissions([...selectedPermissions]);
    }
  };

  const handleChangeAllCheckList = (
    value: any,
    tab: string,
    status: string,
  ) => {
    if (status === 'true') {
      getValue(permissionList, `[${tab}][${0}].items.length`, 0) > 0
        ? getValue(permissionList, `[${tab}][${0}].items`, []).filter(
            (item: object) => {
              if (
                getValue(value, `component`, '') ===
                getValue(item, `component`, '')
              ) {
                getValue(item, `permissions`, []).map((per: any) => {
                  let checkExisted = selectedPermissions.filter(
                    (check: any) => check === getValue(per, `value`, ''),
                  );
                  if (checkExisted.length === 0) {
                    selectedPermissions.push(getValue(per, `value`, ''));
                    setSelectedPermissions([...selectedPermissions]);
                  }
                });
              }
            },
          )
        : getValue(permissionList, `[${tab}][${0}].component`, '') ===
            getValue(value, `component`, '') &&
          getValue(permissionList, `[${tab}][${0}].permissions`, '').map(
            (per: any) => {
              let checkExisted = selectedPermissions.filter(
                (check: any) => check === getValue(per, `value`, ''),
              );
              if (checkExisted.length === 0) {
                selectedPermissions.push(getValue(per, `value`, ''));
                setSelectedPermissions([...selectedPermissions]);
              }
            },
          );
    } else {
      getValue(permissionList, `[${tab}][${0}].items.length`, 0) > 0
        ? getValue(permissionList, `[${tab}][${0}].items`, []).filter(
            (item: object) => {
              if (
                getValue(value, `component`, '') ===
                getValue(item, `component`, '')
              ) {
                let array1 = getValue(value, `permissions`, []).map(
                  (item: any) => item.value,
                );
                let array2 = selectedPermissions;
                setSelectedPermissions(
                  array2.filter((val: any) => !array1.includes(val)),
                );
              }
            },
          )
        : getValue(permissionList, `[${tab}][${0}].component`, '') ===
            getValue(value, `component`, '') &&
          getValue(permissionList, `[${tab}][${0}].permissions`, '').map(
            (per: any) => {
              let array1 = getValue(value, `permissions`, []).map(
                (item: any) => item.value,
              );
              let array2 = selectedPermissions;
              setSelectedPermissions(
                array2.filter((val: any) => !array1.includes(val)),
              );
            },
          );
    }
  };

  const handleSelectAll = (status: any) => {
    if (status === 'true') {
      let arr: any = [];
      allList.map((per: any) => {
        return arr.push(per);
      });
      setSelectedPermissions(arr);
    } else {
      setSelectedPermissions([]);
    }
  };

  function sameMembers(arr1: any, arr2: any) {
    return arr1.some((r: any) => arr2.indexOf(r) >= 0);
  }

  /* -------------------------------------------------------------------------- */
  /*                           Admin Onchange section                           */
  /* -------------------------------------------------------------------------- */
  const handleChangePermission1 = (value: string) => {
    let selected = selectedPermissions1.filter(
      (item: String) => item === value,
    );
    if (getValue(selected, `length`, 0) > 0) {
      let selected = selectedPermissions1.filter(
        (item: String) => item !== value,
      );
      setSelectedPermissions1(selected);
    } else {
      selectedPermissions1.push(value);
      setSelectedPermissions1([...selectedPermissions1]);
    }
  };

  const handleChangeAllCheckList1 = (
    value: any,
    tab: string,
    status: string,
  ) => {
    if (status === 'true') {
      getValue(permissionList1, `[${tab}][${0}].items.length`, 0) > 0
        ? getValue(permissionList1, `[${tab}][${0}].items`, []).filter(
            (item: object) => {
              if (
                getValue(value, `component`, '') ===
                getValue(item, `component`, '')
              ) {
                getValue(item, `permissions`, []).map((per: any) => {
                  let checkExisted = selectedPermissions1.filter(
                    (check: any) => check === getValue(per, `value`, ''),
                  );
                  if (checkExisted.length === 0) {
                    selectedPermissions1.push(getValue(per, `value`, ''));
                    setSelectedPermissions1([...selectedPermissions1]);
                  }
                });
              }
            },
          )
        : getValue(permissionList1, `[${tab}][${0}].component`, '') ===
            getValue(value, `component`, '') &&
          getValue(permissionList1, `[${tab}][${0}].permissions`, '').map(
            (per: any) => {
              let checkExisted = selectedPermissions1.filter(
                (check: any) => check === getValue(per, `value`, ''),
              );
              if (checkExisted.length === 0) {
                selectedPermissions1.push(getValue(per, `value`, ''));
                setSelectedPermissions1([...selectedPermissions1]);
              }
            },
          );
    } else {
      getValue(permissionList1, `[${tab}][${0}].items.length`, 0) > 0
        ? getValue(permissionList1, `[${tab}][${0}].items`, []).filter(
            (item: object) => {
              if (
                getValue(value, `component`, '') ===
                getValue(item, `component`, '')
              ) {
                let array1 = getValue(value, `permissions`, []).map(
                  (item: any) => item.value,
                );
                let array2 = selectedPermissions1;
                setSelectedPermissions1(
                  array2.filter((val: any) => !array1.includes(val)),
                );
              }
            },
          )
        : getValue(permissionList1, `[${tab}][${0}].component`, '') ===
            getValue(value, `component`, '') &&
          getValue(permissionList1, `[${tab}][${0}].permissions`, '').map(
            (per: any) => {
              let array1 = getValue(value, `permissions`, []).map(
                (item: any) => item.value,
              );
              let array2 = selectedPermissions1;
              setSelectedPermissions1(
                array2.filter((val: any) => !array1.includes(val)),
              );
            },
          );
    }
  };

  const handleSelectAll1 = (status: any) => {
    if (status === 'true') {
      let arr: any = [];
      allList1.map((per: any) => {
        return arr.push(per);
      });
      setSelectedPermissions1(arr);
    } else {
      setSelectedPermissions1([]);
    }
  };

  const [activeTab, setActiveTab] = useState(1);
  const handleActiveTab = (tab: any) => {
    setActiveTab(tab);
  };

  const customStyles: StylesConfig = {
    placeholder: (defaultStyles) => {
      return {
        ...defaultStyles,
        color: '#dadce0',
      };
    },
    control: (provided: Record<string, unknown>, state: any) => ({
      ...provided,
      height: 43,
      border: state.isFocused ? '1px solid #dadce0' : '1px solid #dadce0',
      boxShadow: state.isFocused ? '0px 0px 0px #dadce0' : 'none',
      '&:hover': {},
    }),
  };

  return (
    <Layout>
      <Header />
      {!isLoading &&
      !getValue(props, `subTabPermissionList`, []).includes(
        'admin_user_controls_roles_permission',
      ) ? (
        <NoAccessPage />
      ) : (
        <>
          <RolesNavigation
            id={params.id}
            handleSubmit={handleSubmit}
            isLoading={submitLoading}
            url={`/admin/user-controls/roles`}
            headerTitle={'Create Role'}
            permissions={props.permissions}
          />
          <div className="add-rolls-main-wrapper">
            <div className="rolls-wrapper">
              <div className="rolls-wrapper__form-wrapper">
                <div className="rolls-wrapper__form">
                  <div className="rolls-wrapper__form-group form-group">
                    <label
                      htmlFor="title"
                      className="rolls-label rolls-label-error"
                    >
                      Role Name <span>*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Enter Role Name"
                      className="form-control rolls-form-control"
                      id="title"
                      autoComplete="off"
                      value={getValue(request, `title`, '')}
                      onChange={(e: any) =>
                        setRequest({ ...request, title: e.target.value })
                      }
                    />
                  </div>
                  <div className="rolls-wrapper__form-group form-group">
                    <label htmlFor="countries" className="rolls-label">
                      Countries
                    </label>
                    <InputField
                      inputType="INPUT_REACT_SELECT"
                      placeholder="Choose Countries"
                      className="form-control w-100"
                      name="countries"
                      id="countries"
                      options={countryList}
                      value={
                        getValue(request, `countries`, []).length > 0
                          ? countryList.filter((item: any) =>
                              getValue(request, `countries`, []).some(
                                (country: any) =>
                                  getValue(country, `id`, '') ===
                                    getValue(item, `id`, '') ||
                                  getValue(country, `name`, '') ===
                                    getValue(item, `name`, ''),
                              ),
                            )
                          : []
                      }
                      onChange={(e: any) => handleChangeCountries(e)}
                      styles={{
                        ...customStyles,
                        menu: (provided: any) => ({
                          ...provided,
                          zIndex: 9999,
                        }),
                      }}
                      isClear
                      isMulti
                    />
                  </div>
                  <div className="rolls-wrapper__form-group form-group">
                    <label htmlFor="states" className="rolls-label">
                      States
                    </label>
                    <InputField
                      inputType="INPUT_REACT_SELECT"
                      placeholder="Choose States"
                      className="form-control w-100"
                      name="states"
                      id="states"
                      options={stateList}
                      disabled={request.countries.length === 0}
                      value={
                        getValue(request, `states`, []).length > 0
                          ? stateList.filter((item: any) =>
                              getValue(request, `states`, []).some(
                                (state: any) =>
                                  getValue(state, `id`, '') ===
                                    getValue(item, `id`, '') ||
                                  getValue(state, `name`, '') ===
                                    getValue(item, `name`, ''),
                              ),
                            )
                          : []
                      }
                      onChange={(e: any) => handleChangeStates(e)}
                      styles={{
                        ...customStyles,
                        menu: (provided: any) => ({
                          ...provided,
                          zIndex: 9999,
                        }),
                      }}
                      isClear
                      isMulti
                    />
                  </div>
                  <div className="rolls-wrapper__form-group form-group">
                    <label htmlFor="locations" className="rolls-label">
                      Locations
                    </label>
                    <InputField
                      inputType="INPUT_REACT_SELECT"
                      placeholder="Choose Locations"
                      className="form-control w-100"
                      name="locations"
                      id="locations"
                      options={locationList}
                      disabled={request.states.length === 0}
                      value={
                        getValue(request, `locations`, []).length > 0
                          ? locationList.filter((item: any) =>
                              getValue(request, `locations`, []).some(
                                (location: any) =>
                                  getValue(location, `id`, '') ===
                                    getValue(item, `id`, '') ||
                                  getValue(location, `name`, '') ===
                                    getValue(item, `name`, ''),
                              ),
                            )
                          : []
                      }
                      onChange={(e: any) => handleChangeLocations(e)}
                      styles={{
                        ...customStyles,
                        menu: (provided: any) => ({
                          ...provided,
                          zIndex: 9999,
                        }),
                      }}
                      isClear
                      isMulti
                    />
                  </div>
                  <div className="rolls-wrapper__form-group form-group">
                    <label htmlFor="travel_type_access" className="rolls-label">
                      Travel Type
                    </label>
                    <InputField
                      inputType="INPUT_REACT_SELECT"
                      placeholder="Choose Travel Type"
                      className="form-control w-100"
                      name="travel_type_access"
                      id="travel_type_access"
                      options={[
                        { value: 'domestic', label: 'Domestic' },
                        { value: 'international', label: 'International' },
                        { value: 'both', label: 'Both' },
                      ]}
                      value={
                        request.travel_type_access
                          ? [
                              {
                                value: request.travel_type_access,
                                label:
                                  request.travel_type_access === 'domestic'
                                    ? 'Domestic'
                                    : request.travel_type_access ===
                                        'international'
                                      ? 'International'
                                      : 'Both',
                              },
                            ]
                          : []
                      }
                      onChange={(e: any) =>
                        setRequest({
                          ...request,
                          travel_type_access: getValue(e, `value`, null),
                        })
                      }
                      styles={{
                        ...customStyles,
                        menu: (provided: any) => ({
                          ...provided,
                          zIndex: 9999,
                        }),
                      }}
                      isClear
                    />
                  </div>
                </div>
                <div className="rolls-wrapper__form-group form-group">
                  <label
                    htmlFor="descriptiom"
                    className="rolls-label rolls-label-error"
                  >
                    Description <span>*</span>
                  </label>
                  <InputField
                    inputType="TEXTAREA"
                    placeholder="Enter Description"
                    className="form-control w-100"
                    name="description"
                    id="description"
                    value={getValue(request, `description`, '')}
                    onChange={(e: any) =>
                      setRequest({ ...request, description: e.target.value })
                    }
                    label="Description"
                    validator={simpleValidator}
                  />
                </div>
                <RolesTabNavigateion
                  activeTab={activeTab}
                  handleActiveTab={handleActiveTab}
                />
                {activeTab === 1 && (
                  <RolesSection
                    allList={allList}
                    handleSelectAll={handleSelectAll}
                    selectedPermissions={selectedPermissions}
                    isLoading={isLoading}
                    mainPermissions={mainPermissions}
                    handleChangeAllCheckList={handleChangeAllCheckList}
                    handleChangePermission={handleChangePermission}
                    sameMembers={sameMembers}
                    name="client"
                  />
                )}
                {activeTab === 2 && (
                  <RolesSection
                    allList={allList1}
                    handleSelectAll={handleSelectAll1}
                    selectedPermissions={selectedPermissions1}
                    isLoading={isLoading}
                    mainPermissions={mainPermissions1}
                    handleChangeAllCheckList={handleChangeAllCheckList1}
                    handleChangePermission={handleChangePermission1}
                    sameMembers={sameMembers}
                    name="admin"
                  />
                )}
              </div>
            </div>
          </div>
        </>
      )}
      <div className=" w-100">
        <img src="/images/footer-image.svg" className="img-fluid" />
      </div>
    </Layout>
  );
};

export default AdminUserControlRolesDetails;
